export const APA_CORRECTION_STATUS_REQUEST = 'APA_CORRECTION_STATUS_REQUEST';
export const APA_CORRECTION_STATUS_SUCCESS = 'APA_CORRECTION_STATUS_SUCCESS';
export const APA_CORRECTION_STATUS_FAIL = 'APA_CORRECTION_STATUS_FAIL';